import { render, staticRenderFns } from "./user-chats.vue?vue&type=template&id=47766f98&scoped=true&"
import script from "./user-chats.vue?vue&type=script&lang=js&"
export * from "./user-chats.vue?vue&type=script&lang=js&"
import style0 from "./user-chats.vue?vue&type=style&index=0&id=47766f98&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47766f98",
  null
  
)

export default component.exports